import { logger } from '@mpt-fo/common/telemetry';
import { TimelineModel } from '../../../shared/models/timeline.model';
import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-timeline',
	templateUrl: './timeline.component.html',
	styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {
	@Input() hideStepDescription: boolean;
	@Input() hideProgressBar: boolean;
	@Input() stepsArray: TimelineModel[];
	@Input() timeLineType: 'OLD_DESIGN' | 'NEW_DESIGN' | 'KAMONA_DESIGN' | 'ONBOARDING_DESIGN';
	@Input() displayType: 'step' | 'percentage' | 'custom';
	@Input() noFlex = false;
	OLD_DESIGN = 'OLD_DESIGN';
	NEW_DESIGN = 'NEW_DESIGN';
	KAMONA_DESIGN = 'KAMONA_DESIGN';
	ONBOARDING_DESIGN = 'ONBOARDING_DESIGN';
	@Input() disableCompleteBadge: boolean;
	DEFAULT_MOBILE = 1000;
	@Input() mobileTimeLine: boolean;
	@Input() title: string;
	@Input() breakPoint: number;
	browserWidth: number;
	isMobile: boolean;
	currentStep: TimelineModel;
	currentStepIndex: number;
	mobileNote: string;
	@Input() addTimelineTail: boolean;
	@Input() withCustomTail: boolean = false;
	@Input() onboarding = false;
	constructor() {
		// This is intentional
	}

	setTimeLineType(type) {
		this.timeLineType = type;
	}

	ngOnInit(): void {
		this.initialize();
	}

	setMobile(browserWidth) {
		const mobile = this.breakPoint || this.DEFAULT_MOBILE;
		this.isMobile = browserWidth <= mobile;
	}

	initialize() {
		if (!this.timeLineType) {
			this.setTimeLineType(this.OLD_DESIGN);
		}
		this.setBrowserWidth(window.innerWidth);
	}

	setBrowserWidth(width) {
		this.browserWidth = width;
		this.setMobile(width);
	}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setBrowserWidth(window.innerWidth);
	}

	getCurrentStepProgress = () => {
		if (!this.stepsArray || this.stepsArray.length < 1) {
			return 0;
		}
		this.currentStep = this.stepsArray.find((x) => x.state === 'active');
		this.currentStepIndex = this.stepsArray.indexOf(this.currentStep);
		return (100 / this.stepsArray.length) * this.currentStep?.number;
	};

	getStepDescription() {
		try {
			if (!this.stepsArray || this.stepsArray.length < 1) {
				return '';
			}
			const currentStep = this.stepsArray.find((x) => x.state === 'active');
			this.mobileNote = currentStep.mobileNote;
			return currentStep.description;
		} catch (err) {
			logger.error('error from Time line ', err);
		}
	}
}
